import { render, staticRenderFns } from "./SliderV6.vue?vue&type=template&id=6b9d2491&"
import script from "./SliderV6.vue?vue&type=script&lang=js&"
export * from "./SliderV6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports